export default "__VITE_ASSET__bcef3c70__"